/*
 * Language Suggestion
 *
 * Handle language suggest for other websites in the DD network
 */

ckdc.ready( function( $ ) {
    var currentLanguage = ckdc.html.data( 'language' );
    var suggestLanguage = null;

    // get user prefered language
    var preferedLanguage = Cookies.get('ckdc-prefered-language');
    if ( typeof preferedLanguage !== 'undefined' ) {
    	if(preferedLanguage == currentLanguage) {
    		return false;
    	}
		suggestLanguage = preferedLanguage;
    } else {

    	// get web browser language
		var languages = navigator.languages || navigator.language || navigator.userLanguage;
		if ( languages ) {

			// handle either array of languages or single language
			if ( ! Array.isArray( languages ) ) {
				languages = [ languages ];
			}

			$.each( languages, function( i, l ) {
				if ( typeof l !== 'string' ) {
			    	return; // continue
				}

				// language string can be of a number of forms: "en_US", "sv", "es-MX" etc, try to get language part
				l = l.split( /[_-]/ )[0].toLowerCase();

				// is this current language?
				if ( l === currentLanguage ) {
				    return false; // break
				}

				// is language available?
				if ( typeof ckdc.s[ l + '_language_available' ] === 'string' && ckdc.s[ l + '_language_available' ].length > 0 ) {
				    suggestLanguage = l;
				    return false; // break;
				}

				return true; // continue
			} );
		}

    	// get geoip language if browser language is null or English (very common for web browsers!)
    	if( null == suggestLanguage || 'en' == suggestLanguage ) {
	    	geoipLanguage = ckdc.s['geoip_language'];
	    	if ( false !== geoipLanguage && typeof ckdc.s[ geoipLanguage + '_language_available' ] === 'string' ) {

	    		// is this current language?
				if ( geoipLanguage === currentLanguage ) {
				    return false; // break
				}

	    		suggestLanguage = geoipLanguage;
	    	}
	    }

	    if ( null == suggestLanguage || typeof ckdc.s[ suggestLanguage + '_language_available' ] !== 'string' ) {
			return;
	    }
	}

    /*
     * Place language suggestion
     * 1. after .huge-feature-content for front page
     * 2. after <header id="header"> for other places
     */
    var suggestAfter = $(".huge-feature-content-box");
		
    if (!suggestAfter.length) {
      suggestAfter = $("header#header");
    }
    if (suggestAfter.length) {
      var languageUrl = ckdc.s[suggestLanguage + "_url"];
      var languageFlagUrl = ckdc.s[suggestLanguage + "_flag_url"];
      var languageAvailable = ckdc.s[suggestLanguage + "_language_available"];

      suggestAfter.after(
        '<div class="language-suggestion"><a href="' +
          languageUrl +
          '" class="change-prefered-language" data-language="' +
          suggestLanguage +
          '"><img width="25px" height="25px" src="' +
          languageFlagUrl +
          '" /> ' +
          languageAvailable +
          "</a></div>"
      );
    }
} );
